import axios from "axios";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_NEW_REQUEST_HISTORY,
  GET_SUPPLIER_REQUEST_HISTORY,
} from "../../../../config/constants";
import axiosHelper from "../../../../axiosHelper";
import { apiErrors } from "../../../../helper";
export function fetchSupplierRequestHistory(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getSupplierRequestHistory}`, {
      params: {
        EmployeeId: filter?.EmployeeId,
        page: filter.current_page,
        pageSize: filter.per_page,
        SupplierName: filter.SupplierName,
        SortBy: filter?.sortField,
        ApproverName: filter?.UserName,
        Status: filter?.Action,
        SortOrder: filter.sortOrder,
        RequestNo: filter.SupplierRepositoryRequestNo,
        RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
        RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
        ActionFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
        ActionToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
      }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_SUPPLIER_REQUEST_HISTORY,
            payload: {
              data: response.status === 204 ? [] : response?.data?.Result,
              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
      });
  };
}
